export function getUnit(value: number): number {
  const unit = Math.floor(Math.log(value) / Math.log(1000));

  return unit > 3 ? 3 : unit;
}
